import { MarketplaceCards } from "@garantidos/components"

import Text from "@mobi/ds/components/Text"

import CardFooter from "../AccompanyCard/components/CardFooter"

import useFinishedContent from "./hooks"

import "./style.scss"

import LikertComponent from "../LikertComponent/index"

const FinishedContent = () => {
  const { handleMarketplaceCallback } = useFinishedContent()
  return (
    <div className="innerContainer finishedContent">
      <LikertComponent />
      <Text as="h2" className="finishedContent__title">
        achamos que pode te interessar
      </Text>
      <MarketplaceCards
        app="cgi"
        marketplaceCallback={handleMarketplaceCallback}
      />
      <CardFooter />
    </div>
  )
}

export default FinishedContent
